import * as amplitude from '@amplitude/analytics-browser';
import { Callout } from '@liveauctioneers/hammer-ui-core/callout';
import { getBidderId } from '@/redux/modules/account/user/user.selectors';
import { H2 } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { H4 } from '@liveauctioneers/hammer-ui-core/text';
import { useAmplitudeExperiments } from '@/utils/amplitude/experiments/utils/useAmplitudeExperiments';
import { useAppSelector } from '@/redux/hooks';

export const AmplitudeExperimentFlags = () => {
    const { variants } = useAmplitudeExperiments();
    const bidderId = useAppSelector(getBidderId);

    const deviceId = amplitude.getDeviceId();

    return (
        <div className="flex w-1/2 flex-col gap-sm smMax:w-full">
            <H2>Current Amplitude Experiment Flags</H2>
            <div className="flex flex-col gap-sm">
                <H4>BidderID: {bidderId}</H4>
                <H4>DeviceID: {deviceId}</H4>
            </div>
            <Callout
                message="To change variants, go to the Amplitude dashboard and add your bidderID or deviceID to the variant you want to see"
                primaryButton={{
                    onClick: () =>
                        window.open(
                            'https://app.amplitude.com/experiment/auctiontechnologygroup/experiments',
                            '_blank'
                        ),
                    text: 'Open Dashboard',
                }}
                status="info"
                title="Handling variants"
            />

            <table className="border-collapse border border-border-secondary">
                <thead>
                    <tr>
                        <th className="border border-border-secondary p-2">Feature Flag</th>
                        <th className="border border-border-secondary p-2">Variant</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.entries(variants).map(([key, variant]) => (
                        <tr
                            className="odd:bg-background-secondary"
                            key={key}
                        >
                            <td className="border border-border-secondary p-2 capitalize">{key.replace(/-/g, ' ')}</td>
                            <td className="border border-border-secondary p-2 capitalize">{variant.value}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
